// extracted by mini-css-extract-plugin
export default {"wrapper":"HamburgerButton-module__wrapper___GrefI","checkbox":"HamburgerButton-module__checkbox___YzeY6","checkboxLabel":"HamburgerButton-module__checkboxLabel___puhJW"};